import { defineStore } from 'pinia';

/**
 * Moments worth a seasonal flourish, raised by the app and picked up by whichever theme is live. Each counter only
 * ever goes up, so a watcher sees every new moment.
 */
export const useSeasonalCelebrationsStore = defineStore('seasonalCelebrations', () => {
  const claimsResolved = ref(0);

  function claimResolved() {
    claimsResolved.value += 1;
  }

  return { claimResolved, claimsResolved };
});
